import { NgModule } from '@angular/core';
import {
  CategoryTotalQuantityPipe,
  CategoryTotalSalesPipe
} from './category-total.pipe';

@NgModule({
  declarations: [CategoryTotalQuantityPipe, CategoryTotalSalesPipe],
  exports: [CategoryTotalQuantityPipe, CategoryTotalSalesPipe]
})
export class CategoryTotalPipeModule {}
